var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroceryListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.63 22.7286L28.673 22.4959C29.4826 18.1152 29.8874 15.9249 28.688 14.4835C27.4885 13.042 25.2611 13.042 20.8063 13.042L16.8997 13.042C12.4448 13.042 10.2174 13.042 9.01796 14.4835C7.81849 15.9249 8.22329 18.1152 9.03288 22.4959L9.07589 22.7286C9.65442 25.859 9.94369 27.4241 11.0556 28.3494C12.1676 29.2747 13.7593 29.2747 16.9427 29.2747L20.7632 29.2747C23.9466 29.2747 25.5383 29.2747 26.6503 28.3494C27.7622 27.4241 28.0515 25.859 28.63 22.7286Z",
    stroke: "#0E204D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85309 14.7256V14.7256C8.08542 16.9535 9.74053 19.2744 12.097 19.2744L25.609 19.2744C27.9655 19.2744 29.6207 16.9536 28.8531 14.7256V14.7256",
    stroke: "#0E204D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 19.4286V13C14.0001 10.2386 16.2386 8 19.0001 8V8C21.7615 8 24.0001 10.2386 24.0001 13V20",
    stroke: "#0E204D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroceryListIcon);
export default __webpack_public_path__ + "static/media/groceryListIcon.0d9503d3a67c0af00ac8eda139288bc7.svg";
export { ForwardRef as ReactComponent };